export const DOMAIN = 'DOMAIN';
export const SCENARIO = 'SCENARIO';
export const LEXICAL_UNIT = 'LEXICAL_UNIT';
